import React from "react";
// import { Link } from "react-router-dom";
// import Flip from "react-reveal/Flip";

const Summary = () => {
	return (
		<div className="summary bg-dark-theme mt-n2">
			<div className="container-fluid">
				<div className="container px-0">
					<div className="row justify-content-md-stretch px-3 py-5">
						<h2 className="text-white font-weight-bold display-5 mb-4">Summary</h2>
						<p className="text-light mb-4">
							A creative doer, engaging and insightful design professional who is motivated by a desire to solve problems,
							design thoughtful and engaging products with the intention to solve the users need by improving processes and
							customers experience while also possitively impacting Company growth.
						</p>
						<p className="text-light mb-4">
							With the proven ability to work within the constraints of an existing design system to make improvements to
							certain parts of a digital product. I can fit into various creative space as a UX designer, Product designer,
							graphic designer, or UI designer. I like to take ownership of each project and really put in all my energy into
							coming up with solutions that are human centred and feasible to implement while also solving business Goals.
						</p>
						<p className="text-light mb-4">
							As word of wisdom says "Talent wins games, but teamwork and intelligence win championships." I have no problem
							collaborating with other designers, researchers, and managers to come up with feasible and easy-to-implement
							solutions. I’m a great communicator and like to detail the specifics of each task I complete to my team.
						</p>
					</div>

					<div className="container px-md-0">
						<h2 className="text-white font-weight-bold display-5 mb-4">Contributions</h2>
						<div className="row align-items-stretch justify-content-md-stretch px-0 px-md-3 pb-5">
							<div className="col-md-6 col-lg-5 col-xl-4 px-0 my-3 pr-md-2">
								<div className="d-flex justify-content-between items-center h-100 border rounded-lg">
									<div className="p-md-2 h-100">
										<div className="rounded p-3 p-lg-4 testimonial h-100">
											<div className="d-flex justify-content-between mb-3">
												<h3 className="font-weight-bold">Design Right 1.0&2.0</h3>
												<span className="opacity-2 index font-weight-bold">01</span>
											</div>
											<p>
												In conjuction with 5 other amazing Designer Experts, we were able to train about 150
												students of the University of Ilorin in Product Designs and most of them are now crushing
												gigs as UI/UX Designers.
											</p>
										</div>
									</div>
								</div>
							</div>

							<div className="col-md-6 col-lg-5 col-xl-4 px-0 my-3 pl-md-2">
								<div className="d-flex justify-content-between items-center h-100 border rounded-lg">
									<div className="p-md-2 h-100">
										<div className="rounded p-3 p-lg-4 testimonial h-100">
											<div className="d-flex justify-content-between mb-3">
												<h3 className="font-weight-bold">Core Team Member FOF Ilorin</h3>
												<span className="opacity-2 index font-weight-bold">02</span>
											</div>
											<p>
												Team up with a group of amazing Designer and Experts, I assisted in hosting series of
												programms and Event to promote the vision of the community: A place where users can come
												together to help each other
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Summary;
